var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatarDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1018",
    "data-name": "Trac\\xE9 1018",
    d: "M38.614,41.928C31.377,27.08,19.138-28.393,3.956-16.484s26.611,33.595.353,66.9-18.395,69.643-5.9,74.239S45.85,56.776,38.614,41.928Z",
    transform: "translate(196.996 672.454) rotate(45)",
    fill: "#5a5a5a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_236",
    "data-name": "Ellipse 236",
    cx: 35,
    cy: 35,
    r: 35,
    transform: "translate(-6842.5 4535)",
    fill: "#006cff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Avatar_default",
    transform: "translate(6730 -4420.301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2790",
    "data-name": "Groupe 2790"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2787",
    "data-name": "Groupe 2787",
    transform: "translate(-6849.5 3762)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2393",
    "data-name": "Groupe 2393"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_188",
    "data-name": "Ellipse 188",
    cx: 35,
    cy: 35,
    r: 35,
    transform: "translate(121 659)",
    fill: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_de_masques_1819",
    "data-name": "Groupe de masques 1819",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_187",
    "data-name": "Ellipse 187",
    cx: 35,
    cy: 35,
    r: 35,
    transform: "translate(121 659)",
    fill: "#5a5a5a"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_de_masques_1855",
    "data-name": "Groupe de masques 1855",
    transform: "translate(114 -114)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user_2_",
    "data-name": "user (2)",
    transform: "translate(-6856.442 4545.795)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2789",
    "data-name": "Groupe 2789",
    transform: "translate(26.11 6.119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2788",
    "data-name": "Groupe 2788",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1058",
    "data-name": "Trac\\xE9 1058",
    d: "M124.592,0a13.8,13.8,0,1,0,13.8,13.8A13.838,13.838,0,0,0,124.592,0Z",
    transform: "translate(-100.993)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Soustraction_3",
    "data-name": "Soustraction 3",
    d: "M23.029,25.481,0,24.4V17.841A19.014,19.014,0,0,1,13.757-.426a13.821,13.821,0,0,0,4.42,3.033A13.634,13.634,0,0,0,23.6,3.722,13.706,13.706,0,0,0,33.319-.3,19.01,19.01,0,0,1,46.665,17.841V24.4L23.029,25.481Z",
    transform: "translate(0 28.326)",
    fill: "#fff"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarDefault);
export default __webpack_public_path__ + "static/media/avatar_default.00589f4ace32a7eaa8fbd550bd5a1cae.svg";
export { ForwardRef as ReactComponent };